const initialState = {
  activeMenuIndex: 0
};

export default function menuReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_MENU_ACTIVE_STATUS':
      return { ...state, activeMenuIndex: action.payload };
    default:
      return state;
  }
}